<template>
  <div class="main-layout-root rtl">
    <div class="animated-background">
      <div class="floating-elements">
        <span class="element code">{ }</span>
        <span class="element book">📚</span>
        <span class="element graduation">🎓</span>
        <span class="element tech">💻</span>
        <span class="element atom">⚛️</span>
        <span class="element formula">∑</span>
        <span class="element infinity">∞</span>
        <span class="element binary">01</span>
        <span class="element circuit"></span>
        <span class="element grid"></span>
      </div>
    </div>

    <v-navigation-drawer
      app
      permanent
      location="right"
      color="#2F3061"
      class="rtl custom-drawer"
      width="280"
    >
      <div class="drawer-header pa-4">
        <img 
          src="@/assets/soufara.png"
          alt="سفراء العلم"
          class="drawer-logo"
        />
        <div class="welcome-text">{{ welcomeMessage }}</div>
      </div>

      <v-divider class="drawer-divider"></v-divider>

      <v-list class="nav-list">
        <v-list-item-group v-model="activeItem" mandatory>
          <v-list-item
            v-for="(item, index) in filteredMenuItems"
            :key="item.title"
            :value="index"
            @click="navigate(item.route)"
            class="nav-item"
            rounded="lg"
          >
            <template v-slot:prepend>
              <v-icon :icon="item.icon || 'mdi-default-icon'" class="nav-icon"></v-icon>
            </template>
            <v-list-item-title class="nav-title">{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar 
      app 
      color="#2F3061" 
      class="custom-app-bar rtl"
      elevation="0"
    >
    
      <v-spacer></v-spacer>
      <v-toolbar-title class="app-title">مركز سفراء العلم للتدريب</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="handleLogout" color="white" class="logout-btn">
        <v-icon color="white">mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main class="main-content">
      <v-container fluid class="pa-6">
        <router-view />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'MainLayout',
  data() {
    return {
      drawer: true,
      items: [
        { title: 'لوحة التحكم', icon: 'mdi-view-dashboard', route: '/dashboard', roles: ['admin', 'CEO', 'HR', 'Reception'] },
        { title: 'حجز قاعة', icon: 'mdi-door-open', route: '/book-room', roles: ['admin', 'CEO', 'HR', 'Reception'] },
        { title: 'حجز دورة', icon: 'mdi-book-open-variant', route: '/course-booking', roles: ['admin', 'CEO', 'HR', 'Reception'] },
        { title: 'حجز مساحة دراسة', icon: 'mdi-desk-lamp', route: '/book-space', roles: ['admin', 'CEO', 'HR', 'Reception'] },
        { title: 'تسليم عهدة', icon: 'mdi-cash-register', route: '/custody-handover', roles: ['admin', 'Reception'] },
        { title: 'القاعات', icon: 'mdi-door', route: '/rooms', roles: ['admin', 'CEO', 'HR'] },
        { title: 'الدورات', icon: 'mdi-school', route: '/courses', roles: ['admin', 'CEO', 'HR'] },
        { title: 'مساحات الدراسة', icon: 'mdi-desk', route: '/study-spaces', roles: ['admin', 'CEO', 'HR'] },
        { title: 'الاستراحات', icon: 'mdi-coffee', route: '/breaks', roles: ['admin', 'CEO', 'HR'] },
        { title: 'المستخدمين', icon: 'mdi-account', route: '/users', roles: ['admin', 'CEO', 'HR'] },
        { title: 'التقارير', icon: 'mdi-file-chart', route: '/reports', roles: ['admin', 'CEO', 'HR'] }
      ],
      activeItem: 0
    };
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapGetters('auth', ['userRoles', 'hasAnyRole']),
    welcomeMessage() {
      return `مرحباً، ${this.currentUser?.name || this.currentUser?.username || 'زائر'}`;
    },
    filteredMenuItems() {
      // Get the current user's roles
      const roles = this.userRoles;
      console.log('Current user roles:', roles);
      
      // For development/testing - if no roles, show all items
      if (!roles || roles.length === 0 || (roles.length === 1 && roles[0] === 'user')) {
        console.log('No specific roles found, showing all menu items for development');
        return this.items;
      }
      
      // Filter menu items based on user roles
      const filtered = this.items.filter(item => {
        // If no roles specified for the item, show to everyone
        if (!item.roles || item.roles.length === 0) {
          return true;
        }
        
        // Check if user has any of the required roles for this menu item
        const hasAccess = roles.some(role => item.roles.includes(role));
        console.log(`Menu item "${item.title}" with route "${item.route}" access:`, hasAccess);
        return hasAccess;
      });
      
      console.log('Filtered menu items:', filtered);
      return filtered;
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    navigate(route) {
      console.log(`Navigating to route: ${route}`);
      this.$router.push(route);
    },
    handleLogout() {
      this.logout();
      this.$router.push('/login');
    }
  },
  mounted() {
    console.log('MainLayout mounted, current user:', this.currentUser);
    if (this.$route.path === '/') {
      // Check if there are any filtered menu items before navigating
      if (this.filteredMenuItems.length > 0) {
        console.log(`Initial navigation to: ${this.filteredMenuItems[this.activeItem].route}`);
        this.navigate(this.filteredMenuItems[this.activeItem].route);
      } else {
        // If no menu items are available for the user, redirect to login
        this.logout();
        this.$router.push('/login');
      }
    }
  }
};
</script>

<!-- MainLayout specific styles only -->
<style scoped>
.main-content {
  margin-right: 280px !important;
  width: calc(100% - 280px) !important;
  background: transparent;
  padding-right: 0 !important;
  min-height: 100vh;
}

.app-title {
  color: white;
  font-size: 1.25rem;
  font-weight: 500;
}

.logout-btn {
  color: white;
  transition: transform 0.2s ease;
}

.logout-btn:hover {
  transform: scale(1.1);
}

/* Custom scrollbar */
:deep(.v-navigation-drawer__content::-webkit-scrollbar) {
  width: 6px;
}

:deep(.v-navigation-drawer__content::-webkit-scrollbar-track) {
  background: rgba(255, 255, 255, 0.1);
}

:deep(.v-navigation-drawer__content::-webkit-scrollbar-thumb) {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

:deep(.v-navigation-drawer__content::-webkit-scrollbar-thumb:hover) {
  background: rgba(255, 255, 255, 0.3);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .drawer-logo {
    width: 150px;
  }
  
  .app-title {
    font-size: 1.1rem;
  }

  .main-content {
    margin-right: 0 !important;
    width: 100% !important;
  }
  
  :deep(.v-app-bar) {
    padding-right: 0 !important;
  }
}

/* Fix for app bar positioning in production */
:deep(.v-app-bar) {
  padding-right: 280px !important;
  width: 100% !important;
  z-index: 1004 !important;
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
}

/* Ensure main content is positioned correctly */
:deep(.v-main) {
  padding-top: 64px !important;
  padding-right: 0 !important;
}

/* Make sure container has proper padding */
:deep(.v-container) {
  max-width: 100%;
  width: 100%;
  padding-right: 24px !important;
  padding-left: 24px !important;
}

/* Fix for production build layout issues */
:deep(.v-application) {
  direction: rtl !important;
}

:deep(.v-application .v-navigation-drawer--permanent) {
  transform: translateX(0) !important;
  position: fixed !important;
  right: 0 !important;
  top: 0 !important;
  height: 100vh !important;
  z-index: 1005 !important;
}
</style>
